import capitalize from 'lodash/capitalize';
import { LogOut } from 'lucide-react';

import { useAuth } from '@chainlit/react-client';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { Translator } from 'components/i18n';

export default function UserNav() {
  const { user, logout } = useAuth();

  if (!user) return null;
  const displayName = user?.display_name || user?.identifier;

  const name =
    (user?.metadata as any)?.name ||
    (user?.metadata as any)?.email ||
    user?.identifier ||
    '';
  
  const email = (user?.metadata as any)?.email || '';
  const role = (user?.metadata as any)?.role || '';
  const aiops_admin = (user?.metadata as any)?.aiops_admin || false;
  const incident_comms_admin = (user?.metadata as any)?.incident_comms_admin || false;
  const fullName = (user?.metadata as any)?.full_name || '';
  
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="relative h-8 w-8 rounded-full">
          <Avatar className="h-8 w-8">
            <AvatarImage src={user?.metadata.image} alt="user image" />
            <AvatarFallback className="bg-primary text-primary-foreground font-semibold">
              {capitalize(name[0])}
            </AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end" forceMount>
        <DropdownMenuLabel className="font-normal">
            <div className="flex flex-col gap-2">
              <p className="text-sm font-semibold leading-none">{fullName || name}</p>
              <p className="text-xs text-muted-foreground">{email}</p>
              
              {/* Platform Role */}
              <div className="flex items-center gap-2">
                <span className="text-[10px] text-muted-foreground font-medium w-20">Platform:</span>
                <span className="inline-flex items-center rounded-md bg-primary/10 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide text-primary">
                  {role || 'User'}
                </span>
              </div>
              
              {/* Incident Communication Role */}
              <div className="flex items-center gap-2">
                <span className="text-[10px] text-muted-foreground font-medium w-20">Incident Comm:</span>
                <span className="inline-flex items-center rounded-md bg-emerald-500/10 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide text-emerald-600 dark:text-emerald-400">
                  {incident_comms_admin ? 'Admin' : 'User'}
                </span>
              </div>
            </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => logout(true)}>
          <Translator path="navigation.user.menu.logout" />
          <LogOut className="ml-auto" />
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
